import {
    bindProjectsApiBootstrap,
    createProject,
    getProject,
    listProjects,
    listProjectRuns,
    updateProject
} from "../api-client/projects-api.js";
import {
    getClerkAccessToken,
    getClerkBrowserClient,
    getCurrentSession,
    openClerkOrganizationProfile,
    openClerkSignIn,
    subscribeClerkAuthChange,
    syncClerkAccountUi,
    signOutCurrentSession
} from "../api-client/clerk-browser.js";

export function bindProjectsBootstrapRuntime(deps = {}) {
    const {
        bindProjectsClient = null,
        locationHref = "",
        getAccessToken = getClerkAccessToken,
        getSession = getCurrentSession,
        signInWithEmail = () => openClerkSignIn({
            locationHref,
            getClient: getClerkBrowserClient
        }),
        signOut = () => signOutCurrentSession({
            getClient: getClerkBrowserClient
        }),
        openOrganizationProfile = () => openClerkOrganizationProfile({
            getClient: getClerkBrowserClient
        }),
        getAuthClient = () => getClerkBrowserClient(),
        subscribeAuthChange = (listener) => subscribeClerkAuthChange({
            getClient: getClerkBrowserClient,
            listener
        }),
        syncAuthUi = ({ userButtonNode, organizationSwitcherNode } = {}) => syncClerkAccountUi({
            getClient: getClerkBrowserClient,
            userButtonNode,
            organizationSwitcherNode
        }),
        handleAuthChange = () => {},
        refreshCloudAuthUi = () => {},
        info = () => {},
        warn = () => {}
    } = deps;

    return bindProjectsApiBootstrap({
        bindProjectsClient,
        listProjects,
        createProject,
        getProject,
        updateProject,
        listProjectRuns,
        getAccessToken,
        getSession,
        signInWithEmail,
        signOut,
        openOrganizationProfile,
        syncAuthUi,
        getAuthClient,
        subscribeAuthChange,
        handleAuthChange,
        refreshCloudAuthUi,
        info,
        warn
    });
}
